import { useEffect, useState } from "react";
import { loadBonusVenues, peekBonusVenues, type BonusVenue } from "@/data/bonus";

/**
 * The public list of bonus venues (`bonus_venues()`, cached 5 minutes per
 * tab). Null while loading; [] when none, before §33, or on a network error.
 * Starts from the settled cache (the feed warms it), so it is rarely null.
 */
export function useBonusVenues(enabled = true): BonusVenue[] | null {
  const [rows, setRows] = useState<BonusVenue[] | null>(() => (enabled ? peekBonusVenues() : null));
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void loadBonusVenues().then((r) => {
      if (!cancelled) setRows(r);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return rows;
}
